/*  eslint no-param-reassign: ["error", { "props": false }]*/

import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import clone from 'clone';
import {
  Form,
  Grid,
} from 'semantic-ui-react';
import { required } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class UnitLayoutSpecificationForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    preset: PropTypes.shape({
      name: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    name: '',
    shortName: '',
    description: '',
  }
  constructor(props) {
    super(props);
    const preset = Object.assign({}, UnitLayoutSpecificationForm.defaultValues, props.preset || {});
    this.state = {
      preset,
      oriPreset: clone(preset),
      errMessages: [],
    };
    this.validation = {
      name: createRef(),
      shortName: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    let preset = Object.assign({}, UnitLayoutSpecificationForm.defaultValues, this.state.preset);
    let oriPreset = this.state.oriPreset;
    if (JSON.stringify(this.props.preset) !== JSON.stringify(nextProps.preset)) {
      preset = Object.assign(preset, nextProps.preset);
      oriPreset = clone(preset);
    }
    this.setState({ preset, oriPreset });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { preset } = this.state;
    AppForm.validate(this.validation, preset)
      .then((validations) => {
        this.props.onSubmit(validations, preset);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleInputChange = (event, data) => {
    const { preset } = this.state;
    preset[data.name] = data.value;
    this.setState({ preset }, () => {
      this.handleCheckChanges();
    });
  }
  render() {
    const { t } = this.props;
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Grid.Row>
            <Grid.Column>
              <Form.Group widths="equal">
                <AppForm.Input
                  label={t('Name', { ns: TRANSLATION_FILES.translation })}
                  name="name"
                  value={this.state.preset.name}
                  onChange={this.handleInputChange}
                  ref={this.validation.name}
                  validation={[required]}
                />
                <AppForm.Input
                  label={t('Short Name', { ns: TRANSLATION_FILES.screens })}
                  name="shortName"
                  value={this.state.preset.shortName}
                  onChange={this.handleInputChange}
                  ref={this.validation.shortName}
                  validation={[required]}
                />
              </Form.Group>
              <Form.TextArea
                label={t('Description', { ns: TRANSLATION_FILES.screens })}
                name="description"
                value={this.state.preset.description}
                onChange={this.handleInputChange}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(UnitLayoutSpecificationForm);



// WEBPACK FOOTER //
// ./src/containers/ProjectUnitSpecifications/Form.jsx